export class BooleanParser {
    /** @inheritdoc */
    parseValue(rawValue) {
        if (typeof rawValue === 'string' &&
            (rawValue === 'false' || rawValue === '0')) {
            return false;
        }
        return Boolean(rawValue);
    }
}
// use a shared static instance for performance instead of
// instantiating a new instance for every use
BooleanParser.shared = new BooleanParser();
//# sourceMappingURL=boolean.js.map